module.exports = __webpack_public_path__ + "img/mazer-1.346e6d04.jpg";